<template>
  <div class="ai-content-loader">
    <div class="ai-content-loader__loading-tagline">
      <LoaderIcon small />
      <AkParagraph weight="bold">
        {{ t('account.brands.createCampaigns.editor.toolbar.insertAiContent.drawer.loading', { count: campaignApplicableLanguages.length }) }}
      </AkParagraph>
    </div>
      <div class="ai-content-loader__skeleton">
        <AkSkeleton v-for="i in 19" :key="i" :class="`ai-content-loader__skeleton-line${i}`" />
      </div>
  </div>
</template>

<script setup lang="ts">
import LoaderIcon from '@monolith/legacy/components/loader-icon.vue';
import { AkParagraph, AkSkeleton } from '@ankorstore/design-system';
import { useI18n } from 'vue-i18n';
import { campaignApplicableLanguages } from './config';

defineOptions({
  name: 'AiContentLoader',
});

const { t } = useI18n();

</script>

<style lang="scss" scoped>
.ai-content-loader {
  &__loading-tagline {
    @apply ds-flex ds-items-center ds-gap-4;
  }

  @for $i from 1 to 20 {
    .ai-content-loader__skeleton-line#{$i} {
      grid-area: line#{$i};
    }
  }

  &__skeleton {
    @apply ds-mt-6 ds-gap-3;
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-template-areas:
      "line1 line1 line1 line1 line1 line1"
      "line2 line2 line2 line2 line2 line2"
      "line3 line3 line3 line3 line3 ."
      ". . . . . ."
      "line4 line4 . . . ."
      "line5 line5 line5 . . ."
      "line6 line6 line6 . . ."
      "line7 line7 line7 . . ."
      ". . . . . ."
      "line8 line8 line8 line8 . ."
      ". . . . . ."
      "line9 . . . . ."
      "line10 line10 line10 . . ."
      "line11 line11 . . . ."
      "line12 line12 line12 line12 . ."
      ". . . . . ."
      "line13 line13 line13 line13 line13 ."
      "line14 line14 line14 line14 line14 ."
      "line15 line15 line15 line15 line15 ."
      ". . . . . ."
      "line16 line16 line16 line16 . ."
      ". . . . . ."
      "line17 line17 . . . ."
      "line18 line18 . . . ."
      "line19 . . . . .";
  }

}
</style>
